import { MinusCircleOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import {
  Affix,
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Switch,
  Table,
  message,
} from 'antd';
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { BsBox2, BsBoxSeam, BsCurrencyDollar, BsImages, BsUpcScan } from 'react-icons/bs';
import { Link, useHistory } from 'react-router-dom';

import ModalSelectProductView from '../../components/modalSelectProduct';
import ProductImage from '../../components/productImage';
import { formatCurrency } from '.././../utils/format';
import { formatThousands, parseThousands } from '../../utils/numberInput';
import {
  GROUP_SKU_REQUIRED_FIELDS,
  findMissingSkuFields,
  missingSkuFieldsMessage,
} from '../product/sku';
import {
  PRODUCT_DESCRIPTION_MAX_LENGTH,
  PRODUCT_TITLE_MAX_LENGTH,
  nonNegativeRule,
  productDescriptionRules,
  productTitleRules,
  requiredText,
  trimTextFields,
} from '../../utils/formRules';
import useBrandStore from '../profile/brandStore';
import { clearDraft } from './draft';
import './Product.less';
import { GroupProductContenxt } from './ProductDataContext';
import SingleImageUpload from './SingleImageUpload';

const { TextArea } = Input;

/** Талбарууд картын бүтэн өргөнөөр сунахгүй — зүүн талд багцлагдана */
const FORM_MAX_WIDTH = 960;

/** Хадгалахын өмнө эхэн/төгсгөлийн илүү зайг цэвэрлэх текст талбарууд */
const TRIMMABLE_TEXT_FIELDS = ['title', 'detail'];

/**
 * Тоон талбар. Утгыг ЗОРИУДААР засварладаггүй — өмнө нь `min` болон "-"-г хаах
 * `onKeyDown` нь буруу утгыг чимээгүй өөрчилдөг тул хэрэглэгч бичсэнээсээ өөр
 * утга хадгалагдсаныг мэдэхгүй үлддэг байсан. Шалгуурыг дүрмүүд хийж, алдааг ил
 * харуулна.
 */
const numberFieldProps = {
  style: { width: '100%' },
};

/** Картын толгой: дүрс + текст (Барааны дэлгэрэнгүй, Хүргэлт үүсгэхтэй ижил) */
const CardTitle = ({ icon: Icon, children }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
    <Icon style={{ display: 'block', fontSize: '1em' }} />
    {children}
  </span>
);

const ProductAdd = () => {
  const [form] = Form.useForm();
  const isBrandAdded = useBrandStore((state) => state.isListChanged);

  const history = useHistory();

  const productContext = useContext(GroupProductContenxt);
  const sender = productContext.labelInfo.productItem;
  /**
   * Сонгосон дэд бараа болон формын утгууд нь контекстэд байдаг — контекст нь
   * sessionStorage-д draft болгож бичдэг тул refresh хийхэд сэргэнэ.
   */
  const { selectedProducts, setSelectedProducts, formValues, setFormValues } = productContext;

  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [brandLoading, setBrandLoading] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  // Давхар дарахад багц хоёр удаа үүсэхээс сэргийлнэ
  const [submitting, setSubmitting] = useState(false);
  const [searchResult, setSearchResult] = useState();
  const [searchText, setSearchText] = useState('');
  const [productFilter, setProductFilter] = useState({
    brand: '',
    category: '',
  });

  if (productContext.productBaseSku) {
    form.setFieldsValue({
      baseSku: productContext.productBaseSku,
    });
  }

  useEffect(() => {
    setCategoryLoading(true);
    axios
      .post('/api/v1.0/product/category')
      .then(({ data }) => {
        // Жагсаалт ирээгүй ч `[]` хэвээр — `undefined` болбол сонголт унана
        setCategoryList(data?.result?.docs ?? []);
      })
      .catch((e) => {
        console.error('Category list fetch error: ', e);
      })
      .finally(() => setCategoryLoading(false));
  }, []);

  useEffect(() => {
    setBrandLoading(true);
    axios
      .post('/api/v1.0/product/group')
      .then(({ data }) => {
        setBrandList(data?.result?.docs ?? []);
      })
      .catch((e) => {
        console.error('Brand list fetch error: ', e);
      })
      .finally(() => setBrandLoading(false));
  }, [isBrandAdded]);

  useEffect(() => {
    const volume = sender.long * sender.wide * sender.hight;
    productContext.onChangeProductVolume(volume);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sender.long, sender.wide, sender.hight]);

  useEffect(() => {
    const payload = {
      merchantCode: sender.merchantCode,
      categoryCode: sender.category,
      plainText: sender.title,
      type: sender.type,
      size: sender.size,
      color: sender.color,
      outputMinLength: 5,
      outputMaxLength: 10,
      textLength: 80,
    };

    if (sender.title !== '' && sender.merchantCode !== '' && sender.category !== '') {
      axios
        .post('/api/v1.0/product/sku', payload)
        .then(({ data }) => {
          if (data.statusCode === 200) {
            productContext.onChangeBaseSku(data.baseSKU);
          }
        })
        .catch((e) => {
          console.error('Base SKU generate error: ', e);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sender.category]);

  const onHandleHasReturn = (event) => {
    const checked = event;
    productContext.changeLevelInfo('productItem', 'hasReturn', checked);
  };

  const onSearchProduct = (val, event, page = 1, options = {}) => {
    const {
      brand = productFilter.brand,
      category = productFilter.category,
      reset = false,
    } = options;

    if (loading && !reset) return;

    setLoading(true);
    const searchValue = val || '';
    setSearchText(searchValue);

    //Брэнд болон Категори filter
    const filterQuery = `${brand ? `&brand=${encodeURIComponent(brand)}` : ''}${
      category ? `&category=${encodeURIComponent(category)}` : ''
    }`;

    axios
      .get(
        `/api/v1.0/product/search?query=${searchValue}${
          page ? `&page=${page}` : ''
        }${`&group=true`}${filterQuery}`
      )
      .then(({ data }) => {
        setLoading(false);
        if (data.statusCode === 200) {
          setSearchResult(data.result);

          if (data?.result?.docs?.length < 1) {
            // Илэрцгүй хайлтад хуучин жагсаалтыг үлдээж болохгүй — хэрэглэгч
            // тэдгээрийг хайлтад таарсан илэрц гэж эндүүрнэ. Харин 2 дахь ба
            // түүнээс хойших хуудас хоосон ирэх нь зүгээр л жагсаалтын төгсгөл
            // тул тэр үед аль хэдийн татсан мөрүүдийг хөндөхгүй.
            if (reset || page === 1) setProducts([]);

            message.error('Таны хайсан бараа олдсонгүй!', 5);
          } else {
            selectedProducts?.forEach((item) => {
              for (const product of data.result.docs) {
                if (item._id === product?._id) {
                  product.checked = true;
                  break;
                }
              }
            });

            setProducts((prev) => [
              ...(!reset && searchText === searchValue && searchResult?.page !== page ? prev : []),
              ...data.result.docs,
            ]);
          }
        }
      })
      .catch((e) => {
        setLoading(false);
        console.error('Product search error: ', e);
      });
  };

  const onFilterChange = (key, value) => {
    const nextFilter = { ...productFilter, [key]: value || '' };
    setProductFilter(nextFilter);
    onSearchProduct(searchText, null, 1, { ...nextFilter, reset: true });
  };

  const handleCheckProduct = (i, checked) => {
    products[i].checked = checked;
    setProducts([...products]);
  };

  const onOk = () => {
    let selProdClone = [...selectedProducts];
    const listAdd = [];

    products.forEach((item) => {
      const isItemSelected = selectedProducts.find((el) => el?._id === item?._id);

      if (item.checked && !isItemSelected) {
        listAdd.push(item);
      }
      if (!item.checked && isItemSelected) {
        selProdClone = selProdClone.filter((el) => el._id !== item._id);
      }
    });

    setSelectedProducts([...selProdClone, ...listAdd]);
    onCancel();
  };

  const openModal = () => {
    setIsModalVisible(true);
  };

  const onCancel = () => {
    setIsModalVisible(false);
  };

  const generateSKU = () => {
    // Аль талбар нь дутуугаа тодорхой мэдэгдэнэ — `../product/sku.js`-ийг үз
    const missing = findMissingSkuFields(GROUP_SKU_REQUIRED_FIELDS, sender);

    if (missing.length) {
      // Талбар дээр нь улаанаар тэмдэглэнэ. Товч нь формын доод хэсэгт байдаг
      // тул дээрх талбарууд дэлгэцэнд харагдахгүй байж болзошгүй — мэдэгдлээр
      // нь давхар нэрлэж хэлнэ.
      form.validateFields(GROUP_SKU_REQUIRED_FIELDS.map(({ name }) => name)).catch(() => {});
      message.error(missingSkuFieldsMessage(missing), 5);
      return;
    }

    const payload = {
      merchantCode: sender.merchantCode,
      categoryCode: sender.category,
      plainText: sender.title,
      type: sender.type,
      size: sender.size,
      color: sender.color,
      outputMinLength: 5,
      outputMaxLength: 10,
      textLength: 80,
    };

    axios
      .post('/api/v1.0/product/sku', payload)
      .then(({ data }) => {
        if (data.statusCode === 200) {
          form.setFieldsValue({ baseSku: data.baseSKU });
          productContext.onChangeBaseSku(data.baseSKU);
          message.success('SKU код амжилттай үүслээ!');
        }
      })
      .catch((e) => {});
  };

  const onFinishFailed = (values) => {
    const errorNames = values?.errorFields.map((item) => item.name);
    const baseSkuExists = errorNames
      .map((names) => names.includes('baseSku'))
      .find((item) => item === true);
    if (baseSkuExists) {
      message.error('Та SKU кодоо үүсгэнэ үү!', 5);
    }
  };

  const onFinish = async (data) => {
    if (selectedProducts.length === 0) {
      message.error('Бараа оруулаагүй байна. Оруулна уу!');
      return;
    }
    if (!productContext.productBaseSku) {
      message.error('SKU үүсгэгдээгүй байна!');
      return;
    }
    // Бөглөсөн текстийн эхэн/төгсгөлийн илүү зай бараан дээр үлдэхээс сэргийлнэ
    const trimmed = { ...sender, ...trimTextFields(sender, TRIMMABLE_TEXT_FIELDS) };

    let payload = {
      category: sender.category,
      title: trimmed.title,
      baseSku: productContext.productBaseSku,
      productSku: productContext.productBaseSku,
      description: trimmed.detail,
      barCodes: data.barcodes,
      weight: 0,
      stock: 0,
      unit: sender.unit,
      volume: productContext.productVolume,
      vVolume: productContext.productVolume,
      isReturnable: sender.hasReturn,
      price: parseInt(sender.price),
      group: selectedProducts,
      willExpire: false,
      imageCover: sender.image,
      isGroup: true,
    };

    if (sender.type && sender.size && sender.color) {
      payload.attributes = {
        type: sender.type,
        size: sender.size,
        color: sender.color,
      };
    }

    setSubmitting(true);
    try {
      const response = await axios.post(`/api/v1.0/product/groupproduct`, payload);
      if (response.data.statusCode === 200) {
        // Багц үүссэн — хагас дутуу мэдээллийн draft хэрэггүй болно
        clearDraft(productContext.draftKey);
        history.push('/merchant/group/product/list');
        message.success('Бараа амжилттай үүслээ!');
      }
    } catch (e) {
      console.error('Create product group error: ', e);
    } finally {
      setSubmitting(false);
    }
  };

  const columns = [
    {
      key: 'cell1',
      title: '№',
      align: 'center',
      width: 60,
      render: (_, record, index) => `${index + 1}` || '-',
    },
    {
      key: 'cell2',
      title: 'Барааны нэр',
      render: (_, record) =>
        record?.title ? (
          <div>
            <div>{record?.title}</div>{' '}
            <span style={{ fontSize: '12px', color: '#8993A5' }}>{record.productSku}</span>
          </div>
        ) : (
          '-'
        ),
    },
    {
      key: 'cell3',
      title: 'Зураг',
      width: 80,
      render: (_, record) => (
        <ProductImage
          alt={record?.title || 'Барааны зураг'}
          src={record?.imageCover}
          size={40}
          preview
          style={{
            objectFit: 'contain',
            borderRadius: '6px',
            border: '1px solid #DCDFE4',
          }}
        />
      ),
    },
    {
      key: 'cell4',
      title: 'Нэгжийн үнэ',
      align: 'center',
      render: (_, record) => formatCurrency(parseFloat(record?.price)) || '-',
    },
    {
      key: 'cell6',
      title: 'Тоо ширхэг',
      width: 180,
      render: (_, record, index) => (
        <Form.Item
          name={[`products`, `warehous${index}`, 'totalUnit']}
          style={{ marginBottom: '0px' }}
          rules={[
            {
              required: true,
              message: 'Тоо ширхэг оруулна уу!',
            },
            {
              pattern: new RegExp(/^[0-9]+$/),
              message: 'Бүхэл тоо оруулна уу!',
            },
            /* Өмнө нь `min={1}` нь фокус алдахад 1 болгож чимээгүй засдаг байсан */
            {
              type: 'number',
              min: 1,
              message: 'Тоо ширхэг 1-ээс багагүй байх ёстой!',
            },
          ]}
        >
          <InputNumber
            {...numberFieldProps}
            placeholder="0ш"
            onChange={(val) => (selectedProducts[index].stock = val)}
          />
        </Form.Item>
      ),
    },
  ];

  return (
    <>
      <ModalSelectProductView
        isModalVisible={isModalVisible}
        handleOk={onOk}
        handleCancel={onCancel}
        onSearchProduct={onSearchProduct}
        productList={products}
        searchText={searchText}
        searchResult={searchResult}
        handleCheckProduct={handleCheckProduct}
        showFilter
        filterValues={productFilter}
        onFilterChange={onFilterChange}
        loading={loading}
      />

      <Form
        form={form}
        name="basic"
        layout="vertical"
        initialValues={{ ...sender, ...formValues }}
        autoComplete="off"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        /**
         * Баркод, тоо ширхэг зэрэг нь контекстэд өөрөө бичигддэггүй тул формын
         * бүх утгыг нэг мөсөн хадгална — refresh хийхэд сэргэнэ.
         */
        onValuesChange={(_changed, allValues) => setFormValues(allValues)}
      >
        <Space direction="vertical" size={16} style={{ width: '100%', padding: 16 }}>
          <Card size="middle" title={<CardTitle icon={BsImages}>Багц барааны зураг</CardTitle>}>
            <Form.Item
              label="Зураг"
              name="image"
              rules={[{ required: true, message: 'Барааны зураг оруулна уу!' }]}
              style={{ marginBottom: 0 }}
            >
              <SingleImageUpload />
            </Form.Item>
          </Card>

          <Card size="middle" title={<CardTitle icon={BsBox2}>Багц барааны мэдээлэл</CardTitle>}>
            <Row gutter={16} style={{ maxWidth: FORM_MAX_WIDTH }}>
              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  label="Багц барааны нэр"
                  name="title"
                  // Нэгж бараатай ижил хязгаар — сервер 80-аас урт нэр дээр
                  // HTTP 500 буцаадаг ба дэлгэц дээр «Алдаа гарлаа» л харагдана
                  rules={productTitleRules()}
                >
                  <Input
                    placeholder="Энд бич"
                    maxLength={PRODUCT_TITLE_MAX_LENGTH}
                    onChange={productContext.setProductItem('title')}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                {/* SKU үүсгэхэд шаардагддаг тул заавал — `sku.js`-ийг үз */}
                <Form.Item
                  label="Бренд"
                  name="brand"
                  rules={[{ required: true, message: 'Бренд сонгоно уу!' }]}
                >
                  <Select
                    placeholder="Сонгох"
                    onChange={productContext.setProductItem('brand')}
                    loading={brandLoading}
                    options={brandList.map((brand) => ({
                      value: brand?.name,
                      label: brand?.name,
                    }))}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  label="Категори"
                  name="category"
                  rules={[{ required: true, message: 'Категори оруулна уу!' }]}
                >
                  <Select
                    placeholder="Сонгох"
                    onChange={productContext.setProductItem('category')}
                    loading={categoryLoading}
                    options={categoryList.map((category) => ({
                      value: category?.code,
                      label: category?.name,
                    }))}
                  />
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Form.Item
                  label="Барааны тайлбар"
                  name="detail"
                  rules={productDescriptionRules()}
                >
                  <TextArea
                    rows={3}
                    placeholder="Энд бич"
                    maxLength={PRODUCT_DESCRIPTION_MAX_LENGTH}
                    showCount
                    onChange={productContext.setProductItem('detail')}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  label="Буцаагддаг бараа эсэх"
                  name="hasReturn"
                  valuePropName="checked"
                  style={{ marginBottom: 0 }}
                >
                  <Switch onChange={onHandleHasReturn} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card
            size="middle"
            title={<CardTitle icon={BsBoxSeam}>Дэд бараанууд</CardTitle>}
            extra={
              selectedProducts.length > 0 ? (
                <Button
                  type="dashed"
                  style={{ borderColor: '#4BBEDA', color: '#4BBEDA' }}
                  icon={<PlusOutlined />}
                  onClick={() => {
                    if (products.length === 0) onSearchProduct();
                    openModal();
                  }}
                >
                  Бараа нэмэх
                </Button>
              ) : null
            }
          >
            <Space direction="vertical" size={16} style={{ width: '100%' }}>
              <Table
                size="small"
                pagination={false}
                scroll={{ x: 'max-content' }}
                columns={columns}
                dataSource={selectedProducts}
                rowKey={(record, index) => record?._id ?? index}
              />

              {selectedProducts.length === 0 && (
                <Button
                  onClick={() => {
                    if (products.length === 0) onSearchProduct();
                    openModal();
                  }}
                  block
                  icon={<PlusOutlined />}
                  style={{
                    color: '#4BBEDA',
                    height: 48,
                    border: '1px #82C7E8 dashed',
                  }}
                >
                  Бараа нэмэх
                </Button>
              )}
            </Space>
          </Card>

          <Card size="middle" title={<CardTitle icon={BsUpcScan}>Код</CardTitle>}>
            <Row gutter={16} style={{ maxWidth: FORM_MAX_WIDTH }}>
              <Col xs={24} sm={12} lg={8}>
                <Form.Item label="SKU" required>
                  <Space.Compact style={{ width: '100%' }}>
                    <Form.Item
                      name="baseSku"
                      noStyle
                      rules={[{ required: true, message: 'SKU generate хийгдээгүй байна!' }]}
                    >
                      <Input placeholder="SKU код үүсгэх" disabled />
                    </Form.Item>
                    <Button icon={<ReloadOutlined />} onClick={generateSKU} title="SKU үүсгэх" />
                  </Space.Compact>
                </Form.Item>
              </Col>

              <Form.List name="barcodes">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Col key={key} xs={24} sm={12} lg={8}>
                        <Form.Item
                          {...restField}
                          label={`Код ${name + 1}`}
                          name={[name, 'barCode']}
                          rules={[requiredText('Код оруулна уу!')]}
                        >
                          <Input
                            placeholder="Код оруулна уу"
                            onChange={productContext.setProductItem('barCode')}
                            suffix={
                              <MinusCircleOutlined
                                onClick={() => remove(name)}
                                style={{ color: '#8993a5', cursor: 'pointer' }}
                              />
                            }
                          />
                        </Form.Item>
                      </Col>
                    ))}

                    <Col xs={24} sm={12} lg={8}>
                      {/* Талбартай нэг эгнээнд байрлуулахын тулд хоосон label үлдээв */}
                      <Form.Item label={fields.length ? ' ' : 'Код'}>
                        <Button
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                          style={{ color: '#4BBEDA', borderColor: '#4BBEDA' }}
                        >
                          Код нэмэх
                        </Button>
                      </Form.Item>
                    </Col>
                  </>
                )}
              </Form.List>
            </Row>
          </Card>

          <Card size="middle" title={<CardTitle icon={BsCurrencyDollar}>Үнэ</CardTitle>}>
            <Row gutter={16} style={{ maxWidth: FORM_MAX_WIDTH }}>
              <Col xs={24} sm={12} lg={8}>
                <Form.Item
                  label="Зарах үнэ"
                  name="price"
                  rules={[
                    { required: true, message: 'Зарах үнэ оруулна уу!' },
                    nonNegativeRule('Зарах үнэ'),
                  ]}
                  style={{ marginBottom: 0 }}
                >
                  <InputNumber
                    {...numberFieldProps}
                    placeholder="Энд бич"
                    formatter={formatThousands}
                    parser={parseThousands}
                    onChange={productContext.setProductItem('price')}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* Урт формыг гүйлгэхэд ч товчнууд доод талд наалдаж харагдана */}
          <Affix offsetBottom={16}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: 8,
                padding: 12,
                backgroundColor: '#fff',
                border: '1px solid #f1f2f4',
                borderRadius: 8,
                boxShadow: '0 1px 2px rgba(16, 22, 26, 0.04)',
              }}
            >
              <Link to="/merchant/group/product/list">
                <Button htmlType="button">Буцах</Button>
              </Link>
              <Button type="primary" htmlType="submit" loading={submitting}>
                Багц нэмэх
              </Button>
            </div>
          </Affix>
        </Space>
      </Form>
    </>
  );
};

export default ProductAdd;
